import { environment } from "@env/environment";
import { type IBaseResponse } from "@interfaces/IBaseResponse";

import { HttpClient } from "@angular/common/http";
import { inject, Service } from "@angular/core";

export interface IFavoritesResponse extends IBaseResponse {
  data: string[];
}

@Service()
export class FavoritesService {
  private httpClient = inject(HttpClient);

  getFavorites(tenant: string) {
    return this.httpClient.get<IFavoritesResponse>(
      `${environment.API_URL}/api/navigation-favorites/${tenant}`
    );
  }

  saveFavorites(tenant: string, favoriteKeys: string[]) {
    return this.httpClient.put<IFavoritesResponse>(
      `${environment.API_URL}/api/navigation-favorites/${tenant}`,
      { favoriteKeys }
    );
  }
}
